import ThisModule from "./UserProfileSummary";

export default ThisModule;
